import { IPartDetails, IPartManufacturer } from 'parts/types';

export const isPartSetupEditable = (
  part: IPartDetails | null | undefined,
  manufacturer: IPartManufacturer | null | undefined,
  hasEditPermission: boolean
): boolean => hasEditPermission && !!part && !part.familyId && (manufacturer?.id ?? 0) > 0;
